export default "__VITE_ASSET__DIFALr$O__"